import React from 'react';
import {$createGalleryNode, GalleryNode, INSERT_GALLERY_COMMAND} from '../nodes/GalleryNode';
import {COMMAND_PRIORITY_LOW} from 'lexical';
import {INSERT_CARD_COMMAND} from './KoenigBehaviourPlugin';
import {mergeRegister} from '@lexical/utils';
import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';

export const GalleryPlugin = () => {
    const [editor] = useLexicalComposerContext();

    React.useEffect(() => {
        if (!editor.hasNodes([GalleryNode])) {
            console.error('GalleryPlugin: GalleryNode not registered');
            return;
        }
        return mergeRegister(
            editor.registerCommand(
                INSERT_GALLERY_COMMAND,
                async (dataset) => {
                    const cardNode = $createGalleryNode(dataset);
                    editor.dispatchCommand(INSERT_CARD_COMMAND, {cardNode});

                    return true;
                },
                COMMAND_PRIORITY_LOW
            )
        );
    }, [editor]);

    return null;
};

export default GalleryPlugin;
